module.exports = __webpack_public_path__ + "assets/sd_logo_main.02752dba.svg";